<template>
  <v-app >
    <v-toolbar>
      <a href="/" >
        <v-img
          :src="`/static/img/logo.png`"
          :width="30"
        />
      </a>
      <a href="/" style="text-decoration: none;">
        <v-toolbar-title v-text="title" style="margin-left: 1rem"></v-toolbar-title>
      </a>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer class="pa-3" color="primary lighten-1">
      <div class="white--text">&copy; {{ new Date().getFullYear() }} Retec, LLC. All rights reserved.</div>
      <v-spacer></v-spacer>
      <a href="/terms"  class="white--text">Terms of use</a>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      title: 'Retec'
    }
  },
  name: 'App'
}
</script>



// WEBPACK FOOTER //
// src/App.vue